module.exports = __webpack_public_path__ + "img/hot-windows-icon.5cdfe245.png";